
const digest = '617c3ace136d325fbe33f54006cf12fb05fd0ae6f89b95dbe6f4d28a072cbda6';
const classes = {"wrapper":"_wrapper_1evgr_1"};
const css = `._wrapper_1evgr_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: #fff;
  padding: 20px;
  border: 1px solid #eaedf3;
  font-family: Rubik, sans-serif;
  height: fit-content;
  overflow-y: auto;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  